export default {
  getLastFetchTime: state => state.lastFetchTime,
  getExtraPayments: state => state.extraPayments,
  getPageInfo: state => state.pageInfo,
  isPaymentSuccess: state => state.paymentResult === 'success',
  isPaymentFailed: state => state.paymentResult === 'fail',
};



// WEBPACK FOOTER //
// ./src/views/ExtraPayment/store/getters.js